// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"639c317a","639":"f71853e4"}[chunkId] + ".chunk.css";
};